var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsHrz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01953 10C6.91953 10 6.01953 10.9 6.01953 12C6.01953 13.1 6.91953 14 8.01953 14C9.11953 14 10.0195 13.1 10.0195 12C10.0195 10.9 9.11953 10 8.01953 10ZM27.0195 10C25.9195 10 25.0195 10.9 25.0195 12C25.0195 13.1 25.9195 14 27.0195 14C28.1195 14 29.0195 13.1 29.0195 12C29.0195 10.9 28.1195 10 27.0195 10ZM18.0195 10C16.9195 10 16.0195 10.9 16.0195 12C16.0195 13.1 16.9195 14 18.0195 14C19.1195 14 20.0195 13.1 20.0195 12C20.0195 10.9 19.1195 10 18.0195 10Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsHrz);
export default __webpack_public_path__ + "static/media/threeDotsHrz.051f0902c2cd5116051c3c2af4c3b56b.svg";
export { ForwardRef as ReactComponent };